import { useTranslation } from 'react-i18next';
import Page from '@customer/templates/page/Page';
import { DocumentTagPartnerResources } from '@customer/store/apis/documentsApi';
import { QueryTag } from '@customer/store/api';
import { FilterGroup } from '@customer/filters/types';
import usePartnerResources from './usePartnerResources';
import { GridControlled } from '@customer/components/tables/grid/GridControlled';
import CardTable from '@customer/components/tables/card-table/CardTable';
import PageHeader from '@customer/components/layout/page-header/PageHeader';
import { PartnerResourceModel } from '@cas/config/documents';
import { TagDescription } from '@reduxjs/toolkit/query';

const SLICE_KEY_PARTNER_RESOURCES = 'PartnerResources';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  { type: QueryTag.Document, id: DocumentTagPartnerResources },
];

export function PartnerResources() {
  const { t } = useTranslation();

  const { columns, data, hasData, noDataDescription, noResultsDescription, onRowClick } =
    usePartnerResources('NoResourcesAvailable');

  return (
    <Page
      header={
        <PageHeader
          title={t('PartnerResources')}
          sliceKey={SLICE_KEY_PARTNER_RESOURCES}
          tagsToClearOnRefresh={tagsToClearOnRefresh}
          filterProps={{
            filterGroup: FilterGroup.PartnerResources,
            countAll: data?.countAll,
            countFilter: data?.countFilter,
            transKey: 'ShowingResources',
            filteredTransKey: 'ShowingFilteredResources',
          }}
        />
      }
    >
      <CardTable hasData={hasData} noDataDescription={noDataDescription}>
        <GridControlled<PartnerResourceModel>
          sliceKey={SLICE_KEY_PARTNER_RESOURCES}
          rowData={data?.items}
          columnDefs={columns}
          noRowsMessage={noResultsDescription}
          includeHiddenColumnsInQuickFilter={true}
          onRowClick={onRowClick}
        />
      </CardTable>
    </Page>
  );
}

export default PartnerResources;
